import React, { useState, useCallback, useEffect, useRef } from "react";
import { useFormContext } from "./formContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { ColorRing } from "react-loader-spinner";
import {
  sendOTPForTermsheet,
  verifyOTPForTermsheet,
} from "@/lib/credlixBypass";
import { useRouter } from "next/router";
import { pushCleverTapEvent } from "../pushCleverTapEvent";

const ContactFormStep1 = ({ showStep1, hovered }) => {
  const router = useRouter();
  const { locale } = router;
  const eventTriggeredRef = useRef(false);

  const { state, dispatch } = useFormContext();
  const { formData } = state;
  const checkArray = [
    { id: "option1", value: "domestic", name: "Domestic" },
    { id: "option2", value: "export", name: "Export & Import" },
  ];
  const [showUSDInput, setShowUSDInput] = useState(false);
  const [loader, setLoader] = useState(false);
  const [exportValue, setExportValue] = useState("domestic");
  const [currencyVal, setCurrencyVal] = useState(formData?.currency || "");
  const [financeAmt, setFinanceAmt] = useState(formData?.financeAmt || "");
  const [phoneNumberCfForm, setPhoneNumberCfForm] = useState(
    formData?.phone || ""
  );
  const [website, setWebsite] = useState(formData?.website || "");
  const { executeRecaptcha } = useGoogleReCaptcha("");
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [otpBtnDisabled, setOtpBtnDisabled] = useState(true);
  const [getOtp, setGetOtp] = useState(false);
  const [requestIdCfForm, setRequestIdCfForm] = useState("");
  const [phVerifiedCfForm, setPhVerifiedCfForm] = useState(false);
  const [networkErrorCfForm, setNetworkErrorCfForm] = useState(false);
  const [financeAmtError, setFinanceAmtError] = useState(false);
  const [allFieldsError, setAllFieldsError] = useState(false);
  const [responseOfOTP, setResponseOfOTP] = useState(false);
  const [otpIncorrect, setOtpIncorrect] = useState(false);
  const [otpNumericIncorrect, setOtpNumericIncorrect] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [formStarted, setFormStarted] = useState(false); 

  const handleCaptchaSubmitCfForm = useCallback(async () => {
    if (!executeRecaptcha) {
      return false;
    }

    try {
      const gReCaptchaToken = await executeRecaptcha();
      return gReCaptchaToken;
    } catch (error) {
      console.error("Error executing reCaptcha:", error);
    }
  }, [executeRecaptcha]);

  const handleRadioButtonChange = (e) => {
    const val = e.target.value;
    setExportValue(val);
    setShowUSDInput(val === "export");
  };

  const financeAmount = (e) => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
    if (value != "" && value != null && regex.test(value) == true) {
      if (showUSDInput == true) {
        setCurrencyVal("USD");
      } else {
        setCurrencyVal("INR");
      }
      setFinanceAmtError(false);
      setFinanceAmt(value);
    } else {
      setFinanceAmtError(true);
    }
    setFinanceAmt(value);
  };

  const checkPhoneCfForm = (e) => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
    if(!formStarted) {
    pushCleverTapEvent("BL_Sector_Form_Start", { "PageName": 'Sector_Specific_Pages' });
    setFormStarted(true);
    }

    // setOtpBtnDisabled(false);

    if (value !== "" && value.length == 10 && regex.test(value)) {
      setOtpBtnDisabled(false);
      setShowOtpField(false);
      setPhoneNumberCfForm(value);
      setPhoneErrorMsg(false);
      setPhVerifiedCfForm(false);
    } else {
      setPhVerifiedCfForm(false);
      setPhoneErrorMsg(true);
      setOtpBtnDisabled(true);
    }
    setPhoneNumberCfForm(value);
  };

  /* Sent Otp over Phone */
  const sendOTPCfForm = async () => {
    const captchaToken = await handleCaptchaSubmitCfForm();

    setLoader(true);
    setShowOtpField(true);

    try {
      const response = await sendOTPForTermsheet(
        phoneNumberCfForm,
        captchaToken
      );
      const res = await response.json();

      if (response.status == 200) {
        const result = res.result.requestId;
        setGetOtp(true);
        setRequestIdCfForm(result);
        // updateData('Phone', phoneNumber)
        window.gtag("event", "sendOTPfinance", {
          event_category: "Get financed",
          event_label: "Send OTP",
        });
      } else {
        console.error("Error sending OTP:", response.statusText);
      }
    } catch (error) {
      startCountdownCfForm();
    } finally {
      startCountdownCfForm();
    }
  };
  const moveToNextInputCfForm = (currentInput, nextInputId) => {
    let maxLength = parseInt(currentInput.getAttribute("maxLength"));
    let currentLength = currentInput.value.length;

    if (currentLength === maxLength) {
      document.getElementById(nextInputId).focus();
    }
    verifyPhoneNumberCfForm();
  };
  /* Verify Otp over Phone */
  const verifyOTPCfForm = async (enteredOtp) => {
    const captchaToken = await handleCaptchaSubmitCfForm();
    setLoader(true);
    setShowOtpField(true);
    try {
      const response = await verifyOTPForTermsheet(
        requestIdCfForm,
        enteredOtp,
        captchaToken
      );
      if (response.status == 200) {
        const result = response.data;
        setPhVerifiedCfForm(true);
        setGetOtp(false);
        setLoader(false);
        setShowOtpField(false);
        setNetworkErrorCfForm(false);
        setResponseOfOTP(true);
          pushCleverTapEvent("BL_Sector_OTP_Submitted", {
            "PageName": 'Sector_Specific_Pages',
            number: phoneNumberCfForm,
          });
        if (phVerifiedCfForm) {
          setOtpBtnDisabled(true);
        }
      } else {
        setOtpIncorrect(true);
        setPhVerifiedCfForm(false);
      }
    } catch (error) {
      setOtpIncorrect(true);
      setNetworkErrorCfForm(true);
      console.error("verifyOTPCfForm :: Error verifying OTP:", error);
    }
  };

  const verifyPhoneNumberCfForm = () => {
    const enteredOTP = Array.from(
      { length: 6 },
      (_, index) => document.getElementById(`digit${index + 1}`).value
    ).join("");
    if (!/^\d+$/.test(enteredOTP)) {
      setOtpNumericIncorrect(true);
    } else {
      // Check if enteredOTP is a 6-digit number
      if (enteredOTP.length === 6) {
        setOtpNumericIncorrect(false); // Reset incorrect OTP state
        setGetOtp(false);
        setLoader(false);
        verifyOTPCfForm(enteredOTP);
      } else {
        setOtpNumericIncorrect(true);
      }
    }
  };
  const startCountdownCfForm = () => {
    setCountdown(30);
    // setOtpBtnDisabled(true);

    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        const newCountdown = prevCountdown - 1;
        if (newCountdown === 0) {
          clearInterval(countdownInterval);
          setOtpBtnDisabled(false);
        } else {
          setLoader(false);
        }

        return newCountdown >= 0 ? newCountdown : 0;
      });
    }, 500);
  };
  const websiteUrl = (e) => {
    setWebsite(e.target.value);
  };

  const handleNext = () => {
    // Check if all required fields are filled
    if (
      (exportValue &&
        currencyVal &&
        financeAmt &&
        phoneNumberCfForm &&
        phVerifiedCfForm) ||
      state.formData?.otpResponse
    ) {
      setAllFieldsError(false); // Reset any previous error
      if (state.step === 1) {
        showStep1(true);
      }

      dispatch({
        type: "UPDATE_FORM_DATA",
        payload: {
          exportValue: exportValue,
          currency: currencyVal,
          financeAmt: financeAmt,
          phone: phoneNumberCfForm,
          website: website,
          otpResponse: responseOfOTP,
        },
      });
      dispatch({
        type: "NEXT_STEP",
        payload: {
          exportValue: exportValue,
          currency: currencyVal,
          financeAmt: financeAmt,
          phone: phoneNumberCfForm,
          website: website,
          otpResponse: responseOfOTP,
        },
      });
    } else {
      setAllFieldsError(true);
    }
  };
  useEffect(() => {
    if (phVerifiedCfForm) {
      setOtpBtnDisabled(true);
    }
  }, [phVerifiedCfForm, otpBtnDisabled]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 767);
    };
  
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="">
        {(hovered || isSmallScreen) &&
    <>
      <div className="mb-2 rounded-md">
        <div className="flex items-center relative overflow-hidden rounded-lg border border-[#D9D9D9]">
          <input
            value={phoneNumberCfForm}
            name="phoneNumberCfForm"
            onChange={checkPhoneCfForm}
            id="phoneNumberCfForm"
            maxLength={10}
            className="w-[80%] h-[50px] sm:h-[40px] rounded-lg leading-[50px] px-3 text-sm sm:text-[16px] focus:outline-none"
            placeholder="Phone Number*"
          />

          {phVerifiedCfForm && (
            <div className="absolute flex items-center top-[10px] right-[90px] sm:right-[85px] z-10 bg-[#E0FDDF] px-2 sm:px-1 text-xs text-[#299E22] h-[30px] rounded-md">
              <span className="items-center flex">
                <svg
                  className="mr-[5px] "
                  xmlns="https://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="13"
                  height="13"
                >
                  <path
                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                    fill="rgba(41,158,34,1)"
                  ></path>
                </svg>
                Verified
              </span>
            </div>
          )}
          <button
            type="button"
            disabled={otpBtnDisabled}
            onClick={sendOTPCfForm}
            className={`top-0 bottom-0 absolute right-0 rounded-r-md text-xs text-center px-1 w-[81px] disabled:bg-[#ddd] disabled:text-[#888] disabled:cursor-not-allowed bg-yellowcolor text-black`}
          >
            {loader ? (
              <ColorRing
                visible={true}
                height="30"
                width="30"
                ariaLabel="blocks-loading"
                wrapperClass="ringForOtp"
                colors={["#000"]}
              />
            ) : (
              "Send OTP"
            )}
          </button>
        </div>
        {networkErrorCfForm && (
          <div className="text-progressColor4 text-xs mt-[3px]">
            Invalid captcha
          </div>
        )}
        {phoneErrorMsg && (
          <div className="text-progressColor4 text-xs mt-[3px]">
            Please fill this with valid phone number.
          </div>
        )}
        <div className="flex justify-end">
          {getOtp && (
            <div className="flex justify-end text-sm mt-1">
              <span className="text-sm text-brand mr-[5px]">
                Didn't get OTP?{" "}
              </span>
              Resend in {countdown}s
            </div>
          )}
        </div>
      </div>

      {showOtpField && (
        <>
          <label
            className="text-xs font-medium text-secondary mb-0 block"
            htmlFor="digit1"
          >
            Enter OTP
          </label>
          <div className="flex flex-wrap justify-between mb-2 mt-[5px]">
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit1"
              onChange={(e) => {
                verifyPhoneNumberCfForm,
                  moveToNextInputCfForm(e.target, "digit2");
              }}
              maxLength="1"
              pattern="[0-9]"
              required
            />
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit2"
              onChange={(e) => {
                verifyPhoneNumberCfForm,
                  moveToNextInputCfForm(e.target, "digit3");
              }}
              maxLength="1"
              pattern="[0-9]"
              required
            />
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit3"
              onChange={(e) => {
                verifyPhoneNumberCfForm,
                  moveToNextInputCfForm(e.target, "digit4");
              }}
              maxLength="1"
              pattern="[0-9]"
              required
            />
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit4"
              onChange={(e) => {
                verifyPhoneNumberCfForm,
                  moveToNextInputCfForm(e.target, "digit5");
              }}
              maxLength="1"
              pattern="[0-9]"
              required
            />
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit5"
              onChange={(e) => {
                verifyPhoneNumberCfForm,
                  moveToNextInputCfForm(e.target, "digit6");
              }}
              maxLength="1"
              pattern="[0-9]"
              required
            />
            <input
              className="h-[40px] px-1 text-xs text-center rounded-md border border-[#aaa] min-w-0 w-[50px] sm:w-[40px]"
              type="text"
              id="digit6"
              onChange={verifyPhoneNumberCfForm}
              maxLength="1"
              pattern="[0-9]"
              required
            />
          </div>
          {otpNumericIncorrect && (
            <div className="text-progressColor4 text-xs mt-[3px]">
              Incorrect OTP
            </div>
          )}
          {otpIncorrect && (
            <div className="text-progressColor4 text-xs mt-[3px]">
              Please enter correct OTP
            </div>
          )}
        </>
      )}
      <div className="mb-2">
        <input
          type="website"
          name="website"
          value={website}
          onChange={websiteUrl}
          id="website"
          className="w-full  rounded-lg h-[50px] sm:h-[40px] text-sm sm:text-[16px] border border-[#D9D9D9] px-3 focus:outline-none"
          placeholder="Company Website (optional)"
        />
      </div>

      <div className="flex mb-2 rounded-lg h-[50px] sm:h-[40px] border border-[#D9D9D9] items-center">
        {/* Option 1 */}
        {checkArray.map((item, i) => (
          <div
            key={i}
            className="flex items-center h-[50px] sm:h-[40px] w-1/2 justify-center first:border-r first:border-[#D9D9D9] mr-3 sm:mr-1"
          >
            <input
              type="checkbox"
              id={item.id}
              name={exportValue}
              value={item.value}
              checked={exportValue === item.value}
              onChange={handleRadioButtonChange}
              className="cursor-pointer h-3 w-3"
            />
            <label
              htmlFor={item.id}
              className={`cursor-pointer relative pl-1 text-sm sm:text-sm text-[#022B5C]${
                exportValue === item.value ? "" : ""
              }`}
            >
              {item.name}
            </label>
          </div>
        ))}
      </div>
      </>
      }
      <>
        {showUSDInput ? (
          <>
            <div
              className={`flex h-[50px] sm:h-[40px] rounded-lg overflow-hidden items-center border border-[#D9D9D9]`}
            >
              <input
                value="USD"
                name="currency"
                aria-label="Currency"
                readOnly
                className="border-r w-[70px] text-sm text-center h-[50px] sm:h-[40px] leading-[50px] border-[#D9D9D9]"
              />
              <input
                name="financeAmt"
                value={financeAmt}
                onChange={financeAmount}
                id="financeAmt"
                placeholder="Enter Amount*"
                className="border-none text-sm sm:text-[16px] rounded-md px-2 py-1 text-gray-700 focus:outline-none"
              />
              <button
                onClick={handleNext}
                className="disabled:bg-[#999] bg-gradient-to-r text-sm from-[#022D60] to-[#0363C4] text-white px-1 ml-auto mr-[3px] h-[44px] rounded-md hover:bg-blue-700 transition"
              >
                Apply Now
              </button>
            </div>
            {financeAmtError && (
              <p className="text-progressColor4 text-xs mt-[3px">
                This field is required with valid amount
              </p>
            )}
          </>
        ) : (
          <div
            className={`flex h-[50px] sm:h-[40px] rounded-lg overflow-hidden items-center border border-[#D9D9D9]`}
          >
            <input
              value="INR"
              name="currency"
              aria-label="Currency"
              readOnly
              className="border-r w-[70px] text-sm text-center h-[50px] sm:h-[40px] leading-[50px] border-[#D9D9D9]"
            />
            <input
              value={financeAmt}
              name="financeAmt"
              onChange={financeAmount}
              id="financeAmt"
              placeholder="Enter Amount*"
              className="border-none text-sm sm:text-[16px] rounded-md px-2 py-1 text-gray-700 focus:outline-none"
            />
            {!isSmallScreen &&
            <button
              onClick={handleNext}
              className="disabled:bg-[#999] sm:hidden bg-gradient-to-r text-sm from-[#022D60] to-[#0363C4] text-white px-1 ml-auto mr-[3px] h-[44px] rounded-md hover:bg-blue-700 transition"
            >
              Apply Now
            </button>
            }
          </div>
        )}
        {isSmallScreen &&
         <button
              onClick={handleNext}
              className="disabled:bg-[#999] hidden sm:block block bg-gradient-to-r text-sm from-[#022D60] to-[#0363C4] text-white px-1 w-full mt-2 h-[44px] rounded-md hover:bg-blue-700 transition"
            >
              Apply Now
            </button>
      }
      </>

      {allFieldsError && (
        <p className="text-progressColor4 text-xs mt-[3px]">
          Please fill in all required fields and send otp to verify your number
          if not.
        </p>
      )}
    </div>
  );
};

export default ContactFormStep1;
